module.exports = __webpack_public_path__ + "img/f-customer1.31b61354.svg";